<form autocomplete="off" [formGroup]="itemInventoryForm" (ngSubmit)="submitForm()" 
    class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
    <section>
        <!-- Row 1 -->
        <div class="tw-flex">
            <mat-form-field class="tw-w-1/4 tw-p-3">
                <mat-label translate>ITEMS.DETAILS.UNIT</mat-label>
                <!-- <mat-select formControlName="unit">
                    @for(unit of units; track unit.value) {
                        <mat-option [value]="unit.value">{{unit.name}}</mat-option>
                    }
                </mat-select> -->

                <input matInput type="text" formControlName="unit" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUnit">
                <mat-option *ngFor="let option of filteredUnits | async" [value]="option">
                    {{option.name}}
                </mat-option>
                </mat-autocomplete>

            </mat-form-field>
            <mat-form-field class="tw-w-1/4 tw-p-3">
                <mat-label translate>ITEMS.DETAILS.SKU</mat-label>
                <input matInput formControlName="sku">
                <mat-hint [align]="'end'">{{itemInventoryFormService.sku?.value?.length || '0'}}
                    / {{itemInventoryFormService.validators.skuMaxLength}}</mat-hint>
                @if(itemInventoryFormService.sku?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}}
                        (max. {{itemInventoryFormService.validators.skuMaxLength}})
                    </mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-w-1/4 tw-p-3">
                <mat-label translate>ITEMS.DETAILS.CODE</mat-label>
                <input matInput formControlName="code">
                <mat-hint [align]="'end'">{{itemInventoryFormService.code?.value?.length || '0'}}
                    / {{itemInventoryFormService.validators.codeMaxLength}}</mat-hint>
                @if(itemInventoryFormService.code?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}}
                        (max. {{itemInventoryFormService.validators.codeMaxLength}})
                    </mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-w-1/4 tw-p-3">
                <mat-label translate>ITEMS.DETAILS.WEIGHT</mat-label>
                <input matInput type="number" formControlName="weight" step="0.001">
                @if(itemInventoryFormService.weight?.hasError('min')) {
                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                }
            </mat-form-field>
        </div>
    </section>
</form>